import React,{useState,useContext} from 'react';
import AppContext from "../../AppContext";
import { GenForm } from '../Hocs/Hocs';
import {FormService,Api,ModalService,Lang} from "./../../services/Services";
import {BaseSubmit,InputDiv,RegiBtns} from "./../utils/Utils";

const fieldsObj={};
const fields=[
	{name:"email",validation:{isEmail:true,notEmpty:true},labelLang:["forgotten_password","Email"],placeholderLang:["forgotten_password","Email"],toLowerCase:true},
];

const apiFunc=async()=>Api.forgotPassword(fieldsObj.email[0]);

const langText = (area, term, fallback) => {
	if (Lang[area] && Lang[area][term]) {
		return Lang[area][term];
	}
	return fallback;
};

const ForgotPassword=({errors,submit,servError,closeForgot,onOpenForgotUsername})=>{
	const context=useContext(AppContext);
	const [submitDisabled,submitDisabledUpd]=useState(false);
	
	
	fieldsObj.email=useState("");
	const submitFunc=async ()=>{
		submitDisabledUpd(true);
		let res=await submit();
		if(res.success){
			closeForgot();
		}
		else{
			submitDisabledUpd(false);
		}
	}
	
	FormService.fieldsHoist(fields,fieldsObj);

	if(context.UserService.user && !onOpenForgotUsername){return null;}
	return (
		<>
			<h5>{Lang.forgotten_password.Forgot_your_password}</h5>
			<ul className="form">
				{
					fields.map(fieldObj=><li key={fieldObj.name} ><InputDiv   fieldObj={fieldObj}  error={errors[fieldObj.name]}  /></li>)
				}
				{onOpenForgotUsername &&
				<li>
					<p>
						<span className="form-p underline pointer" onClick={onOpenForgotUsername} >{langText("forgotten_password","forget_username_email","Forgot username by email?")}</span>
					</p>
				</li>
				}
			</ul>
			<RegiBtns servError={servError} >
				<BaseSubmit onClick={submitFunc} disabled={submitDisabled} label={Lang.forgotten_password.Get_password}  />
			</RegiBtns>
		
		</>
	);
	
}

export default GenForm(ForgotPassword,{fields,apiFunc,langFail:["errorTexts","sent_fail"],langSuc:["errorTexts","sent_suc"]});
